import { ReactElement } from 'react';
import {
  ModalId,
} from 'shared/constants/modals';
import { AntModalProps } from 'shared/ui/Modal';

interface ModalData extends AntModalProps {
  id: ModalId,
  content: ReactElement
}

export const modalData: ModalData[] = [];
